import { useEffect } from "react"
import { useAuth } from "@/auth"
import { useLocation } from "react-router-dom"

import { useNavigate } from "@be-miniapp/ui/hooks/use-navigate"

import { usePermissionValidatorStore } from "@/store/permission-validator"

export function PermissionWall() {
  const needVerification = usePermissionValidatorStore(
    (state) => state.state === "need-verification"
  )

  const isUnauthorized = usePermissionValidatorStore(
    (state) => state.state === "unauthorized"
  )

  const { isAuthenticated, logout } = useAuth()

  const resetState = usePermissionValidatorStore((state) => state.updateState)

  const setPreventRedirect = usePermissionValidatorStore(
    (state) => state.setPreventRedirect
  )

  const preventRedirect = usePermissionValidatorStore(
    (state) => state.preventRedirect
  )

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    if (!isAuthenticated) return

    if (isUnauthorized) {
      logout()
      navigate("/unauthorized?session_expired=true")
      return
    }

    if (needVerification) {
      if (preventRedirect) {
        setPreventRedirect(false)
        resetState("unverified")
        return
      }

      if (location.pathname === "/verification") return

      const permissionStore = usePermissionValidatorStore.getState()
      if (!permissionStore.returnPath) {
        permissionStore.setReturnPath(
          `${location.pathname}${location.search}${location.hash}`
        )
      }

      navigate("/verification")
    }
  }, [
    needVerification,
    preventRedirect,
    isUnauthorized,
    resetState,
    isAuthenticated,
    logout,
    navigate,
    setPreventRedirect,
    location.pathname,
    location.search,
    location.hash,
  ])

  return null
}
